/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate } from "react-router-dom";

import botn_info from '../../../img/admin/botn-info.png';
import user_icon from '../../../img/admin/uesr-icon.png';
import botn_login from '../../../img/admin/botn-login.png';
import botn_logout from '../../../img/admin/botn-logout.png';

function TitleBar(){
  const navigate = useNavigate();
  //로그인유무
  const adminLoginState = Number(localStorage.getItem('adminLoginState'));
  //로그인한 관리자이름
  const adminName = localStorage.getItem("adminName");

  //로그아웃
  const onLogoutHandler = (e) =>{
    e.preventDefault();
    localStorage.removeItem('adminLoginState');
    localStorage.removeItem('adminIdx');
    localStorage.removeItem('adminName');
    navigate('/LoginAdmin');
  }
  //로그인페이지로 이동
  const onLoginHandler = (e) => {
    navigate('/LoginAdmin');
  }
  //관리자 정보 편집 페이지로 이동
  const onMemberHandler = (e) => {
    e.preventDefault();
    navigate('/Admin/AdminInformation');
  }

  return(
    <div id="admin-head-wrap">
      <div className="center-wrap">
        <div className="f-rightt">
          {adminLoginState === 0 ?
            <button onClick={(e)=>onLoginHandler(e)} className="btn-s"><img src={botn_login} alt=""/>로그인</button>
          :
            <div>
              <div className="info">
                <img src={user_icon} alt=""/>Welcome&nbsp;&nbsp;<span>{adminName}</span>
              </div>
              <button onClick={(e)=>onMemberHandler(e)} className="btn-s"><img src={botn_info} alt=""/>관리자정보</button>
              <button onClick={(e)=>onLogoutHandler(e)} className="btn-s"><img src={botn_logout} alt=""/>로그아웃</button>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default TitleBar;
